import Marquee from "react-fast-marquee";
import { Reveal } from "../components/Reveal";
import { useLang } from "../lib/i18n";
import { IMAGES } from "../lib/content";

const PHOTOS = [
  { src: IMAGES.story1, alt: "Paulina and Louie", tall: true },
  { src: IMAGES.paris, alt: "Paris, under the Eiffel Tower" },
  { src: IMAGES.bear, alt: "With Bear by the lake", tall: true },
  { src: IMAGES.story2, alt: "Paulina and Louie in the gardens" },
  { src: IMAGES.bearSelfie, alt: "Bear, our Saint Bernard", tall: true },
  { src: IMAGES.story3, alt: "Paulina and Louie dancing" },
  { src: IMAGES.pool, alt: "Sunny days in Arizona" },
  { src: IMAGES.hero, alt: "The ring", tall: true },
  { src: IMAGES.story4, alt: "Paulina and Louie" },
  { src: IMAGES.dateNight, alt: "Date night" },
];

export const Gallery = () => {
  const { c } = useLang();
  return (
    <section className="py-28 sm:py-36 overflow-hidden" data-testid="gallery-section">
      <Reveal className="px-6">
        <div className="max-w-6xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.35em] text-[#465220] mb-6">{c.gallery.overline}</p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight">
            {c.gallery.title} <span className="italic text-[#465220]">{c.gallery.titleAccent}</span>
          </h2>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="mt-16">
        <Marquee speed={22} gradient={false} pauseOnHover autoFill>
          {PHOTOS.map((p, i) => (
            <div key={i} className={`mx-3 ${i % 2 === 1 ? "mt-10" : ""}`} data-testid={`gallery-photo-${i}`}>
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className={`${p.tall ? "h-72 sm:h-96" : "h-56 sm:h-72"} w-auto object-cover grayscale-[35%] hover:grayscale-0 hover:scale-[1.02] transition-[filter,transform] duration-700`}
              />
            </div>
          ))}
        </Marquee>
      </Reveal>
    </section>
  );
};
